import React from "react";
// import { ThemeProvider } from "@mui/material/styles";
import { createRoot } from "react-dom/client";
import { hydrateRoot } from "react-dom/client";
// import CssBaseline from "@mui/material/CssBaseline";
import reportWebVitals from "./reportWebVitals";
// import theme from "./theme";
import AppWrapper from "./App.wrapper";
import "./index.css";

// Add preload hints for critical resources
const preloadCriticalResources = () => {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'style';
  link.href = '/static/css/main.chunk.css';
  document.head.appendChild(link);
};

// This component will be pre-rendered by React Snap
const AppRoot = () => {
  // Add a check to prevent flash of unstyled content
  const [isHydrated, setIsHydrated] = React.useState(false);
  
  React.useEffect(() => {
    setIsHydrated(true);
    // Report web vitals after hydration
    reportWebVitals();
  }, []);

  return (
    <div style={{ 
      visibility: isHydrated ? 'visible' : 'hidden',
      opacity: isHydrated ? 1 : 0,
      transition: 'opacity 0.3s ease-in'
    }}>
      <AppWrapper />
    </div>
  );
};

// Check if the code is running in a browser environment (not during pre-rendering)
if (typeof window !== 'undefined') {
  const rootElement = document.getElementById("root");
  
  if (!rootElement) {
    console.error("Root element not found");
  } else {
    // Preload critical resources
    preloadCriticalResources();

    // Conditionally import CSS based on URL (only in browser)
    if (!window.location.href.toLowerCase().includes("careerlauncher")) {
      // import("./index.css"); - already imported above
    } else {
      import("./colourIndexCL.css");
    }

    // Use hydrate if the content has been server-rendered by react-snap
    if (rootElement.hasChildNodes()) {
      console.log("Hydrating existing content");
      hydrateRoot(rootElement, <AppRoot />);
    } else {
      console.log("Rendering from scratch");
      const root = createRoot(rootElement);
      root.render(<AppRoot />);
    }
  }
}

// This allows React Snap to render the app
export default AppRoot;
